<template>
  <div>
    <h2>用户头像图片</h2>
    <br />
    <div style="text-align: center">
      删除违规图片：<input
        v-model="fileUrl"
        style="width: 200px"
        type="text"
        placeholder="请输入违规图片url"
      /><button @click="deleteuserpi">删除</button>
      <br />
      <div v-if="visible" class="toast" :class="type">
        <span>{{ message }}</span>
      </div>
      <br />
    </div>
    <div v-if="pics.length">
        <ul >
        <li v-for="(pic, index) in pics" :key="index">
          <img
            :src="pic.avatar_url"
            :alt="'图片' + index"
            @click="showPicInfo(pic)"
          />
        </li>
      </ul>

      <!-- 分页按钮 -->
      <div class="pagination">
        <br /><br />
        <button @click="prevPage" :disabled="page === 1">上一页</button>
        <span>第 {{ page }} 页</span>
        <button @click="nextPage" :disabled="pics.length < pageSize">
          下一页
        </button>

        <!-- 跳转到指定页面 -->&nbsp;&nbsp;
        <input
          style="width: 80px"
          type="number"
          v-model="jumpPage"
          min="1"
          :max="totalPages"
          placeholder="输入页码"
        />
        <button @click="goToPage">跳转</button>&nbsp;&nbsp;
        <span>共{{ totalPages }}页</span>

        <!-- 每页显示条数 -->&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>当前页面{{ pageSize }}个</span>
        <!-- 每页显示条数 -->&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>总数{{ totalRecords }}个</span>
      </div>
    </div>
    <div v-else>暂无图片</div>

    <!-- 弹窗显示图片信息 -->
    <div v-if="showModal" class="modal" @click="closeModal">
      <div class="modal-content" @click.stop>
        <span class="close" @click="closeModal">&times;</span>
        <h3>图片信息</h3>
        <p><strong>URL：</strong>{{ selectedPic.avatar_url }}</p>
        <img :src="selectedPic.avatar_url" :alt="selectedPic.alt" width="200" />
      </div>
    </div>
  </div>
</template>

<script>
import { userpiclist, deleteuserpi } from "@/api/houtai/index.js";

export default {
  name: "imagePic",
  data() {
    return {
      pics: [], // 图片数据
      showModal: false, // 控制弹窗显示
      selectedPic: {}, // 当前选中的图片
      page: 1, // 当前页码
      pageSize: 100, // 每页数量
      jumpPage: 1, // 输入框中跳转的页码
      totalRecords: 0, // 总记录数
      visible: false, // 控制消息显示与隐藏
      message: "", // 存放消息内容
      type: "info", // 类型：info, success, error
      fileUrl: "",
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords / this.pageSize); // 总页数
    },
  },
  methods: {
    async deleteuserpi() {
      if (this.fileUrl === "") {
        this.message = "不能为空";
        this.visible = true;
        this.visible = true;
        setTimeout(() => {
          this.visible = false;
        }, 2000); // 3秒后自动隐藏
      }

      try {
        const response = await deleteuserpi({ fileUrl: this.fileUrl });
        console.log(response);
        if (response.success) {
          this.message = response.message;
          this.visible = true;
          setTimeout(() => {
            this.visible = false;
          }, 2000); // 3秒后自动隐藏

          this.fetchPics();
        } else {
          this.pics = [];
          console.warn("暂无数据");
        }
      } catch (error) {
        console.error("删除失败：", error);
      }
    },

    // 获取图片列表
    async fetchPics() {
      try {
        const response = await userpiclist({
          page: this.page,
          pageSize: this.pageSize,
        });
        console.log(response);
        if (response.status === 200) {
          this.pics = response.result;
          this.totalRecords = response.total;
        } else {
          this.pics = [];
          console.warn("暂无数据");
        }
      } catch (error) {
        console.error("获取图片列表失败：", error);
      }
    },
    // 显示图片信息弹窗
    showPicInfo(pic) {
      this.selectedPic = pic;
      this.showModal = true;
    },
    // 关闭弹窗
    closeModal() {
      this.showModal = false;
    },
    // 上一页
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchPics();
      }
    },
    // 下一页
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.fetchPics();
      }
    },
    // 跳转到指定页面
    goToPage() {
      if (this.jumpPage >= 1 && this.jumpPage <= this.totalPages) {
        this.page = this.jumpPage;
        this.fetchPics();
      }
    },
  },
  mounted() {
    this.fetchPics();
  },
};
</script>

<style >

img {
  border-radius: 8px;
  cursor: pointer;
  height: 70px;
  margin: 5px;
  width: 70px;
  object-fit: cover;
}

/* 分页按钮 */
.pagination {
  margin: 10px 0;
}
button {
  padding: 5px 10px;
  margin: 0 5px;
  background-color: #428bca;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
input[type="number"] {
  width: 60px;
  padding: 5px;
  margin: 0 5px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
}

.modal-content h3 {
  font-size: 25px;
  line-height: 80px;
  margin-bottom: 10px;
}

.modal-content p {
  font-size: 20px;
  margin-bottom: 20px;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  padding: 20px;
  background-color: red;
}

.close:hover {
  color: #fff;
}
.toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  z-index: 1000;
  transition: opacity 0.3s;
}

.toast.info {
  background-color: #3498db;
}

.toast.success {
  background-color: #2ecc71;
}

.toast.error {
  background-color: #e74c3c;
}
</style>
